import React, { useState } from "react";
import { Container, Span, InputContain, IRow } from "../GodMode";
import InputBox from "../../Generic/InputBox";
import Button from "../../Generic/Button";

const ConsumerShutterTasks = {
	COLLECT: "COLLECT",
};

const CONSUMER_SHUTTER_TASKS_CONFIG = {
	[ConsumerShutterTasks.COLLECT]: { 
		taskType: "collect", 
		name: "Collect Item" 
	},
};

const ConsumerShutter = ({ sendTask, loadingStates }) => {
	const [qpdSlotId, setQpdSlot] = useState();
	const isCollectLoading = loadingStates[CONSUMER_SHUTTER_TASKS_CONFIG[ConsumerShutterTasks.COLLECT].taskType] || false;

	const handleButtonClick = async () => {
		const taskData = qpdSlotId ? { qpdSlotId } : {};
		await sendTask(CONSUMER_SHUTTER_TASKS_CONFIG[ConsumerShutterTasks.COLLECT], taskData);
	}

	return (
		<Container>
			<IRow>
				<InputContain margin="0 1rem 0 0">
					<Span padding="0 0 0.5rem 0" fontSize="1rem" fontWeight="600">
						QPD Slot Id
					</Span>
					<InputBox
						onChange={(e) => {
							setQpdSlot(e.target.valueAsNumber);
						}}
						type="number"
						required
					/>
				</InputContain>
				<Button onClick={handleButtonClick} disabled={isCollectLoading}>
					Collect
				</Button>
			</IRow>
		</Container>
	);
};

export default ConsumerShutter;
